import React from 'react';
import { ceil } from 'lodash';
import { useAppEventContext } from 'modules/taboola-common-frontend-modules/app-events-aggregator';
import { APP_EVENT_TYPE } from 'modules/taboola-common-frontend-modules/app-events-aggregator/appEventType';
import { RecommendationActionBar } from 'modules/taboola-common-frontend-modules/chat-agent/components/RecommendationActionBar/RecommendationActionBar';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage, FormattedNumber } from 'modules/taboola-common-frontend-modules/i18n';

const getCurrencyValue = (value, currency) => {
    return <FormattedNumber value={value} variant="currency" currency={currency} maximumFractionDigits={0} />;
};

export const BudgetRecommendationActionBar = ({ recommendation, onAccept, onClose, budget }) => {
    const { push: pushAppEvent } = useAppEventContext();
    const budgetValue = budget?.value;
    const recommendationValue = recommendation?.value;
    const isBudgetLowerThanRecommendation = budgetValue && budgetValue < recommendationValue;

    const {
        formAccount: { currency },
    } = useFormDataContext();

    const handleAccept = () => {
        pushAppEvent({
            id: 'CAMPAIGN_BUDGET_RECOMMENDATION_ACCEPT',
            type: APP_EVENT_TYPE.CLICK,
        });
        onAccept();
    };

    const handleClose = () => {
        pushAppEvent({
            id: 'CAMPAIGN_BUDGET_RECOMMENDATION_CLOSE',
            type: APP_EVENT_TYPE.CLICK,
        });
        onClose();
    };

    return (
        <div
            data-app-event-visibility
            data-app-event-additional-data={JSON.stringify({ value: `${recommendation?.value} ${currency}` })}
            id="CAMPAIGN_BUDGET_RECOMMENDATION"
        >
            <RecommendationActionBar
                acceptMessage={
                    <FormattedMessage
                        id="abby.set.budget.recommendation"
                        defaultMessage="Set {value}"
                        values={{ value: getCurrencyValue(recommendationValue, currency) }}
                    />
                }
                onAccept={handleAccept}
                onClose={handleClose}
                message={
                    <FormattedMessage
                        id={
                            isBudgetLowerThanRecommendation
                                ? 'abby.budget.lower.than.recommendation.message'
                                : 'abby.budget.recommendation.message'
                        }
                        values={{
                            value: getCurrencyValue(recommendationValue, currency),
                            minValue: getCurrencyValue(ceil(recommendationValue * 0.875), currency),
                            maxValue: getCurrencyValue(ceil(recommendationValue * 1.125), currency),
                        }}
                    />
                }
                chatAgentButtonProps={{
                    id: 'CAMPAIGN_BUDGET_RECOMMENDATION_ASK_AGENT',
                    agentName: 'budget_negotiation',
                    messageId: 'abby.ask.recommendation',
                }}
            />
        </div>
    );
};
